import React from 'react';
import './unauthorized-screen.scss';
import { SVGS } from '@zonofi/zono-money-design-system';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import {
  sendWAEventToParent,
  useAppSelector,
} from '@zonofi/zono-money-helpers';
import { getCustomerInvite, getIsSimulation } from '@zonofi/zono-money-store';
import { onClickBackToWhatsapp } from '@zonofi/zono-money-whatsapp-stack';

export const UnauthorizedScreen: React.FC = () => {
  const inviteDetails = useAppSelector(getCustomerInvite);
  const isSimulation = useAppSelector(getIsSimulation);
  const { seller, waConfig } = inviteDetails;
  return (
    <div className="error-screen-container">
      <div className="error-content">
        <img
          className="error-content-img"
          src={SVGS.Restricted}
          alt=""
          width={'172px'}
          height={'172px'}
        />

        <div className="error-content-body">
          <div className="error-content-body-message">
            <div className="font-primary-semibold error-content-body-message-header">
              User Restricted!
            </div>
            <div className="font-primary error-content-body-message-description">
              You don't have access to this link.
            </div>
          </div>
          <ZoButton
            label={'Back to Whatsapp'}
            onClick={() =>
              onClickBackToWhatsapp({
                whatsappPhoneNo: waConfig?.whatsappPhoneNo,
                workspaceId: seller?.workspaceId,
                isSimulation: isSimulation,
                sendEventToParent: () => {
                  sendWAEventToParent({ unAuthorizedAccess: true });
                },
              })
            }
            className="error-content-body-button font-primary-regular"
          />
        </div>
      </div>
    </div>
  );
};
